/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SweetAlert from 'sweetalert-react';
import 'assets/styles/sweetalert.css';
import { renderToStaticMarkup } from 'react-dom/server';

import { storageKeys } from 'settings';
import { APIHandler, DataHandler, Diploma, StorageHandler, TrainingGrid, ContentHeader, Progress } from 'C4';

const Welcome = () => (
  <div className="access__container">
    <h2>{i18n.translate('trainingScreens.welcome')}</h2>
  </div>
);

const getTotalPages = (res) => {
  let totalPages = 0;
  let firstFourPages = 0;
  if (res) {
    const { chapters } = res.data[0];
    chapters.forEach((chapter, i) => {
      const pages = chapter.total_pages;
      if (i < 10) firstFourPages += pages;
      totalPages += pages;
    });
  }
  return { firstFourPages, totalPages };
};

// Makes sure progress is returned in percentage value
const calculateProgress = (progress, pages) => Math.floor((progress / pages) * 100);


const ViewDiploma = ({ diploma }) => {
  if (diploma !== 100) return null;

  const hasViewedDiploma = localStorage.getItem('hasViewedDiploma');
  if (hasViewedDiploma) return null;

  localStorage.setItem('hasViewedDiploma', true);
  setTimeout(() => {
    document.getElementById('showDiplomaButton').click();
  }, 2000);

  return null;
};

export default class TrainingView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalProgressValue: 0,
      diploma: 0,
      graduated: false,
      popup: false,
      firstName: 'Firstname',
      lastName: 'Lastname',
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.getUserInfo();
    this.getViewedDiploma();
  }

  componentDidUpdate() {
    const { diploma, totalProgressValue, graduated } = this.state;
    if (totalProgressValue >= 100 && diploma !== 100) {
      this.setState({ diploma: 100 });
    }

    this.updateGraduated(diploma, graduated);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  async getViewedDiploma() {
    const hasViewedDiploma = await StorageHandler.load(storageKeys.hasViewedDiploma);

    if (hasViewedDiploma === undefined) {
      StorageHandler.save(storageKeys.hasViewedDiploma, false);
    } else {
      this.setState({ hasViewedDiploma });
    }
  }

  getUserInfo() {
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        this.popupView();
        const { email } = res;
        DataHandler.matchAppId().then((appId) => {
          DataHandler.checkKey(storageKeys.progress, APIHandler.getUserProgress(appId, email)).then((userProgress) => {
            const { firstFour } = this.getTotalProgress(userProgress);
            const { firstFourPages } = getTotalPages(userProgress);
            const percentage = calculateProgress(firstFour, firstFourPages);
            this.setState({ totalProgressValue: percentage >= 97 ? 100 : percentage });
            
            if (percentage >= 97) {
              this.setState({ diploma: 100 });
            } else {
              this.setState({ diploma: 0 });
            }
          });

          StorageHandler.load(storageKeys.user).then((user) => {
            const { first_name: firstName, last_name: lastName } = user;
            this.setState({ firstName, lastName, appId });
          });
        });
      } else {
        this.setState({ totalProgressValue: 0 });
      }
    });
  }

  getTotalProgress(res) {
    let totalProgress = 0;
    let firstFour = 0;
    if (res) {
      const { chapters } = res.data[0];

      StorageHandler.load(storageKeys.user).then((user) => {
        if (user) {
          if (
            user.training_graduated &&
            user.training_graduated !== '0000-00-00 00:00:00' &&
            user.training_graduated !== 'null'
          ) {
            this.setState({ diploma: 100 });
            this.setState({ totalProgressValue: 100 });
            chapters.forEach((chapter) => {
              const updateInfo = {
                chapterId: Number(chapter.chapter),
                lastPage: chapter.total_pages,
                progress: chapter.total_pages,
                email: user.email,
              };
              APIHandler.setUserProgress(updateInfo).then(() => {});
            });
          }
        }
      });

      chapters.forEach((chapter, i) => {
        const progress = Math.min(chapter.progress, chapter.total_pages);
        if (i < 10) firstFour += progress;
        totalProgress += progress;
      });
    }

    return { firstFour, totalProgress };
  }

  async updateGraduated(diploma, graduated) {
    if (diploma >= 100 && !graduated) {
      const d = new Date(Date.now());
      const leading = val => `0${val}`.slice(-2);
      const user = (await StorageHandler.load(storageKeys.user)) || {};
      if (user && user.training_graduated === null) {
        const newUser = user;
        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;
        const appId = await DataHandler.matchAppId();

        const res = await APIHandler.updateUser(appId, user.email, [
          { param: 'sales_companion_registered', val: date },
          { param: 'training_started', val: date },
          { param: 'training_graduated', val: date },
        ]);

        if (res) {
          newUser.response.sales_companion_registered = date;
          newUser.response.training_started = date;
          newUser.response.training_graduated = date;
          StorageHandler.save(storageKeys.user, newUser);
        }
      }
      this.setState({ graduated: true });
    }
  }

  popupView() {
    if (!localStorage.getItem('viewedPopup')) {
      localStorage.setItem('viewedPopup', true);
      this.setState({
        popup: true,
      });
    }
  }

  render() {
    const { history } = this.props;
    const { diploma, totalProgressValue, popup, firstName, lastName } = this.state;

    const close = () => {
      this.setState({
        popup: false,
      });
      localStorage.setItem('viewedPopup', true);
    };

    return (
      <div className="contentContainer trainingView">
        <ContentHeader
          header={i18n.translate('contentHeaders.train')}
          subtitle={i18n.translate('pageDescriptions.train')}
        >
          <div className="container__Progress">
            <div className="container__progressBar">
              <Progress id="progress" value={totalProgressValue} />
              <h6 className="progressText">
              {totalProgressValue}{i18n.translate('trainingScreens.percentageComplete')}
              </h6>
            </div>
            <a
              id="showDiplomaButton" // id used for simulating click
              className={`container__progressDiploma ${totalProgressValue === 100 ? 'completed' : ''}`}
              role="button"
              tabIndex={-1}
              data-fancybox
              data-src="#diploma"
              data-options='{"toolbar" : "true", "buttons" : ["close"]}'
              href="javascript:;"
              style={{ pointerEvents: diploma === 100 ? 'auto' : 'none' }}
            >
              <FontAwesomeIcon icon={['far', 'file-certificate']} className={clsx({ completed: diploma === 100 })} />
              <p className="text__viewDiploma">{i18n.translate('nav.reportCard')}</p>
            </a>
            <style>{'\
            #openWidget { display: block; } '}
            </style>
          </div>
        </ContentHeader>
        <TrainingGrid history={history} />
        <SweetAlert
          title=""
          show={popup}
          html
          text={renderToStaticMarkup(<Welcome close={close} />)}
          customClass="welcome"
          confirmButtonText={i18n.translate('trainingScreens.continue')}
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        />
        {diploma === 100 &&
          <React.Fragment>
            <Diploma
              appId={appId}
              firstName={firstName}
              lastName={lastName}
            />
            <ViewDiploma diploma={diploma} />
          </React.Fragment>}
      </div>
    );
  }
}

Diploma.propTypes = {
  appId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  history: PropTypes.shape(),
};

Diploma.defaultProps = {
  firstName: 'John',
  lastName: 'Doe',
  history: null,
};
